<!-- Page Content -->
<div id="page-content">
  <div class="container">

    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8 col-sm-9">
        <header><h3>{{selEvent.title}}</h3></header>
        <div id="page-main">
          <section id="event-detail">
            <article class="event-detail">
              <section id="event-header">
                <header>
                </header>

                <!--CSS Loader-->
                <section *ngIf="loader">
                  <div class="ph-item" *ngFor="let x of citeRepat">
                    <div>
                      <div class="ph-row">
                        <div class="ph-col-12"></div>
                        <div class="ph-col-12"></div>
                        <div class="ph-col-10"></div>
                        <div class="ph-col-2 empty"></div>
                        <div class="ph-col-2"></div>
                        <div class="ph-col-10 empty"></div>
                      </div>
                    </div>
                  </div>
                </section>
                <!--CSS Loader-->

                <hr>
                <div class="course-count-down" id="course-count-down">
                  <figure class="course-start">
                  </figure>
                  <!-- /.course-start -->

                  <div class="count-down-wrapper">

                    <i class="fa fa-calendar"></i>&nbsp;
                    <h2 class="event-date">{{selEvent.commence_date | date:"EEEE, MMMM d, y"}}
<!--                      - {{selEvent.commence_date | date:"h:mm a"}}-->
                    </h2>


                  </div><!-- /.count-down-wrapper -->

                </div><!-- /.course-count-down -->
                <hr>

              </section><!-- /#course-header -->

              <span id="course-info">

                <div [innerHTML]="selEvent.short_desc"></div>
                <br>
                <div *ngIf="selEvent.long_desc !== 'null'" [innerHTML]="selEvent.long_desc"></div>
                <br>
                <span *ngIf="selEvent.files !== null">
                  <a [href]="selEvent.files" target="_blank" class="btn btn-lg active" role="button" aria-pressed="true">
                    <i class="fa fa-download"></i> Download
                  </a>
                </span>

                <span *ngIf="selEvent.links !== null && selEvent.links !== 'null'">
                  <a [href]="selEvent.links" target="_blank" class="btn btn-lg active" role="button" aria-pressed="true">
                    <i class="fa fa-eye"></i> View
                  </a>
                </span>

              </span>
            </article><!-- /.course-detail -->
          </section><!-- /.course-detail -->
        </div><!-- /#page-main -->

        <div>
          <ng-image-slider #nav
                           [images]="imgCollection"
                           [infinite]="false"
                           [autoSlide]="1"
                           [imageSize]="{width: 200, height: 150}"
                           slideImage="1"></ng-image-slider>
        </div>

      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <aside class="news-small" id="news-small">

            <div class="section-content" *ngIf="selEvent.images !== null">
              <span *ngIf="selEvent.files !== null">
                <a [href]="selEvent.files" target="_blank">
                  <img src="{{selEvent.images}}" alt="" class="add-margin evt-img">
                </a>
              </span>

              <span *ngIf="selEvent.files === null">
                  <img src="{{selEvent.images}}" alt="" class="add-margin evt-img">
              </span>
            </div>

            <span *ngIf="selEvent.video !== null && selEvent.video !== 'null'">
              <iframe width="350" height="250" [src]='safeURL' title="{{selEvent.title}}" allowfullscreen></iframe>
            </span>


          </aside><!-- /.news-small -->

        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
      <!-- end SIDEBAR Content-->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
